import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { ShipmentBundle } from 'api/optimalprint-sdk.d';
import { HttpMethods } from 'api/types';
import useLocale from 'hooks/useLocale';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Accordion from '../../Common/Accordion/Accordion';
import styles from './StudioDeliveryOptions.module.scss';

export interface StudioDeliveryOptionsProps {
  productId: number;
  categoryId: number;
}

const StudioDeliveryOptions: FC<StudioDeliveryOptionsProps> = ({ categoryId, productId }) => {
  const { t } = useTranslation();
  const locale = useLocale();
  const [deliveryData, setDeliveryData] = useState<any>();

  const fetchDeliveryData = async () => {
    const delivery = (await apiRequest(
      endpoints.shipmentPriceV2ListDetailed,
      {
        productIds: [productId],
        categoryId,
        locale,
      },
      HttpMethods.POST,
      'data',
    )) as ShipmentBundle.Entity.API.ShipmentPrice.ShipmentPriceListDetailedV2Response;

    if (
      !delivery ||
      !delivery.products ||
      !delivery.products[0] ||
      !delivery.products[0].details ||
      !(delivery.products[0].details as any).delivery
    ) {
      return;
    }
    setDeliveryData(delivery.products[0].details as any);
  };

  useEffect(() => {
    fetchDeliveryData();
  }, [productId, categoryId]);

  if (!deliveryData || !deliveryData.delivery || !deliveryData.delivery.length) {
    return null;
  }

  return (
    <div className={styles.deliveryOptions}>
      <Accordion title={t('txt_delivery_information')} titleClassName={styles.title} expanded>
        <table>
          <thead>
            <tr>
              <th>{t('txt_dt_shipping_method')}</th>
              <th>{t('txt_dt_est_delivery_dates')}</th>
            </tr>
          </thead>
          <tbody>
            {deliveryData.delivery.map((option: any, i: number) => (
              <tr key={i}>
                <td>{option.displayedName}</td>
                <td align="center">
                  {option?.minDeliveryDay} - {option?.maxDeliveryDay}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <span className={styles.remark}>{t('txt_dt_ordered_time_cards')}</span>
      </Accordion>
    </div>
  );
};

export default StudioDeliveryOptions;
